import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "colored-query" }
const _hoisted_4 = { class: "candidate-list" }

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'

import { findMnemonics } from './wordlist/collectCandidates'
import { ref, computed, Ref } from 'vue'
import ColorizedText from './components/ColorizedText.vue'
import { getChosungCorrespondingAlphabets, koreanDecomposeCharacter } from '@/utils/korDecompose'
import { WordTable } from './wordlist/wordtable'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const query = ref('')
const wordTable = ref(null) as Ref<WordTable | null>

const queryChunked = computed(() => {
  return query.value.split(' ').filter(x => x).map(s => {
    const ret = [] as string[]
    for (const ch of s) {
      const chCode = ch.charCodeAt(0)
      if (chCode >= 0xAC00 && chCode <= 0xD7AF) {
        // Korean character
        const chosung = koreanDecomposeCharacter(ch)[0]
        ret.push(getChosungCorrespondingAlphabets(chosung))
      } else if (chCode >= 0x3131 && chCode <= 0x314E) {
        ret.push(getChosungCorrespondingAlphabets(ch))
      } else if (chCode >= 65 && chCode <= 90) { // Uppercase alphabet
        ret.push(ch.toLowerCase())
      } else if (chCode >= 97 && chCode <= 122) { // Lowercase alphabet
        ret.push(ch)
      }
    }
    return ret.join('')
  })
})

const candidates = computed(() => (wordTable.value !== null) ? findMnemonics(wordTable.value, queryChunked.value) : [])

// Load word table asynchronously
const worker = new Worker(new URL('./wordlist/worker.ts', import.meta.url))
worker.postMessage('init')
worker.onmessage = ({ data }) => {
  wordTable.value = data.wordTable
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Loading), {
      active: wordTable.value === null,
      "background-color": "#aaa"
    }, null, 8, ["active"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event))
      }, null, 512), [
        [_vModelText, query.value]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ColorizedText, {
          texts: queryChunked.value,
          sep: " "
        }, null, 8, ["texts"])
      ])
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(candidates.value, ({mnemonic, permutation}, i) => {
        return (_openBlock(), _createElementBlock("li", { key: i }, [
          _createVNode(ColorizedText, {
            texts: mnemonic.display.split(''),
            "color-index-mapper": permutation
          }, null, 8, ["texts", "color-index-mapper"])
        ]))
      }), 128))
    ])
  ]))
}
}

})